<template>
  <div>
    <i
      v-if="params.value"
      class="fas fa-check success"
      aria-hidden="true"
    />
    <i
      v-else
      class="fas fa-times tertiary-color"
      aria-hidden="true"
    />
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'CheckIcon'
})

</script>
